import { useEffect, useState } from 'react';
import { ILesson } from '../../../../models/disciplines';
import { useLessonStore } from '../../../../../modules/Disciplines/stores/lessonStore';
import LessonCard from '../../../../../modules/Disciplines/components/contentModal/lessonCard';
import { useParams } from 'react-router-dom';
import getSubjectByFilter from '../../../../commom/getSubjectByFilter';
import { IResponseFavorite } from '../../../../../modules/Disciplines/hooks/useContentFavorite';
import { useNewSubjectStore } from '../../../../../modules/Disciplines/stores/newSubjectStore';
import { Typography } from '../../../molecules/Typography';
import { useFinishLesson } from '../../../../hooks/useFinishLesson';
import { useFreemiumLock } from '../../FreemiumLockModal/useFreemiumLock';
import './next-video.css';

const NextVideo = () => {
  const { lessons, setLessons } = useLessonStore();
  const { module, discipline, slug } = useParams();
  const { selectedSubjects } = useNewSubjectStore();
  const { mutate: finishLesson } = useFinishLesson();
  const { isLocked, isUnlocked, openLock } = useFreemiumLock();

  const [main, setMain] = useState<ILesson[]>([]);

  useEffect(() => {
    if (lessons?.length === 0 || !lessons) return;

    setMain(lessons.filter((lesson) => lesson.type === 'main'));
  }, [lessons]);

  const handleDone = (id: string, lessonSlug: string) => {
    if (!lessonSlug) return;

    // Alterna entre marcar e desmarcar como concluído com base no estado atual.
    // UI otimista/instantânea; a requisição é best-effort (sem spinner na resposta).
    const lesson = lessons.find((it) => it.slug === lessonSlug);
    const nextDone = !lesson?.done;

    // Manual: envia explicitamente o próximo estado do toggle (marca/desmarca).
    finishLesson({ slug: lessonSlug, body: { viewed: nextDone } });

    const newLessons = lessons.map((it) =>
      it.slug === lessonSlug ? { ...it, done: nextDone } : it
    );
    setLessons(newLessons);

    setMain((prev) =>
      prev.map((it) =>
        it._id === id ? { ...it, done: nextDone } : it
      )
    );
  };

  const handleFavorite = (data: IResponseFavorite) => {
    setMain((prev) =>
      prev.map((lesson) =>
        lesson._id === data.targetId
          ? { ...lesson, favorite: data.insert === true }
          : lesson
      )
    );
  };

  return (
    <div className='flex flex-col gap-4'>
      <Typography type='title' size='h2'>
        Próximas videoaulas
      </Typography>
      <div
        id='nextVideoList'
        className='flex flex-col gap-4 overflow-y-auto'
      >
        {main?.map((it, i) => (
          <LessonCard
            key={it._id || i}
            lesson={it}
            discipline={discipline ?? ''}
            module={module ?? ''}
            subjectSlug={it.subjects[0].slug}
            subject={getSubjectByFilter(it.subjects, selectedSubjects)}
            slug={slug ?? ''}
            done={it.done}
            favorite={it.favorite}
            onClose={() => {}}
            onDone={(id, lessonSlug) => handleDone(id, lessonSlug)}
            doneLoading={false}
            callback={handleFavorite}
            locked={isLocked(it)}
            onLockedClick={openLock}
            freemiumUnlocked={isUnlocked(it)}
          />
        ))}
      </div>
    </div>
  );
};

export default NextVideo;
